import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import TextAreaField from "../../../ui/TextAreaField";
import Select from "../../../ui/Select";
import StudentModal from "./StudentModal";
import {
  validateRequired,
  validateMaxlength,
} from "../../../../utils/validate";
import { useNavigate } from "react-router-dom";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import {
  getCourseApplicantDetail,
  postUpdateCourseApplicant,
} from "../../../../services/apiCourseApplicant";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Completion from "./Completion";
import { useAuth } from "../../../../contexts/AuthContext";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
import { AUTH_UNIVERSITY } from "../../../../utils/config";

const UpdateCourseApplicant = () => {
  // ユーザー情報
  const { user } = useAuth();
  // 講座ID(サイトID + 講座ID 8桁)
  const { id } = useParams();
  // ユーザーID
  const { userId } = useParams();
  // 確認
  const [isConfirmation, setIsConfirmation] = useState(false);
  // 当選状況
  const [lotteryStatus, setLotteryStatus] = useState([]);
  // 未受講・受講中・受講済み
  const [attendanceStatus, setAttendanceStatus] = useState([]);
  // 申込方法
  const [howApply, setHowApply] = useState([]);
  // 出席・欠席
  const [attendance, setAttendance] = useState([]);
  // 学生選択モーダル表示ステータス
  const [showStudentModalFlag, setShowStudentModalFlag] = useState(false);
  // 学生情報
  const [studentInfo, setStudentInfo] = useState({});
  // 学生情報表示ステータス
  const [studentDisplay, setStudentDisplay] = useState(false);
  // 完了フラグ
  const [isCompFlg, setIsCompFlg] = useState(false);
  // ローディング表示
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  // 初回レンダリング
  useEffect(() => {
    if (user.authority == AUTH_UNIVERSITY) {
      navigate("/admin/404");
    }
    (async function () {
      // ローディング表示開始
      setLoading(true);
      // 区分データ取得
      const lotteryData = await getCodeMasterList({ code: "CD003" });
      if (lotteryData == undefined || !lotteryData) return;
      // 区分データを選択肢としてセット
      setLotteryStatus(
        lotteryData.map((d) => {
          return { text: d.d_text, value: d.d_value };
        })
      );

      // 区分データ取得
      const attendanceStatusData = await getCodeMasterList({ code: "CD004" });
      if (attendanceStatusData == undefined || !attendanceStatusData) return;
      // 区分データを選択肢としてセット
      setAttendanceStatus(
        attendanceStatusData.map((d) => {
          return { text: d.d_text, value: d.d_value };
        })
      );

      // 区分データ取得
      const howApplyData = await getCodeMasterList({ code: "CD005" });
      if (howApplyData == undefined || !howApplyData) return;
      // 区分データを選択肢としてセット
      setHowApply(
        howApplyData.map((d) => {
          return { text: d.d_text, value: d.d_value };
        })
      );

      // 区分データ取得
      const attendanceData = await getCodeMasterList({ code: "CD006" });
      if (attendanceData == undefined || !attendanceData) return;
      // 区分データを選択肢としてセット
      setAttendance(
        attendanceData.map((d) => {
          return { text: d.d_text, value: d.d_value };
        })
      );

      // 講座詳細データ取得
      const data = await getCourseApplicantDetail(id, userId, 1);
      if (data == undefined || !data) return;
      if (Object.keys(data).length === 0) {
        navigate("/admin/404");
      }
      // 講座詳細データセット
      setValue("course_name", data["course_name"]);
      setValue("university_id", data["university_id"]);
      setValue("lottery_status", data["lottery_status"]);
      setValue("login_id", data["login_id"]);
      setValue("name", data["name"]);
      setValue("select_user_id", userId);
      setValue("attendance_status", data["attendance_status"]);
      if (data["how_apply"]) {
        setValue("how_apply", data["how_apply"]);
      }
      setValue("remarks", data["remarks"]);
      [...Array(15)].map((_, i) =>
        setValue("attendance" + (i + 1), data["attendance" + (i + 1)])
      );
      setValue("updated_at", data["updated_at"]);
      // ローディング表示終了
      setLoading(false);
    })();
  }, []);

  // 学生情報
  useEffect(() => {
    if (studentDisplay) {
      // 選択した学生の情報をセット
      setValue("login_id", studentInfo["login_id"]);
      setValue("name", studentInfo["name"]);
      setValue("select_user_id", studentInfo["user_id"]);
    } else {
      // 学生の情報表示を削除
      setValue("login_id", "");
      setValue("name", "");
      setValue("select_user_id", "");
    }
  }, [studentInfo]);

  // 学生選択モーダル表示
  const showStudentModal = () => {
    setShowStudentModalFlag(true);
  };

  // 申込者詳細へ戻る
  const handleBack = (e) => {
    // e.preventDefault();
    navigate(-1);
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  // 登録画面へ戻る
  const handleBackConfirmation = () => {
    setIsConfirmation(false);
    scrollTop();
  };

  // 確認 or 登録
  async function onSubmit(data) {
    if (!isConfirmation) {
      setIsConfirmation(true);
      scrollTop();
    }
    if (isConfirmation) {
      // 申込情報変更
      const json = await postUpdateCourseApplicant(id, userId, data);
      if (json) {
        // 完了画面表示
        setIsCompFlg(true);
        scrollTop();
      }
    }
  }

  return (
    <>
      {isCompFlg ? (
        <Completion
          subtitle="講座申込完了"
          explanation="講座の申込が完了いたしました。"
          link={"/admin/course/detail/" + id + "/" + 2}
          btntext="講座詳細へ戻る"
        ></Completion>
      ) : (
        <div className={styles.main}>
          <ScreenTitle>講座管理</ScreenTitle>
          <SubScreenTitle>申込情報変更</SubScreenTitle>
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <table className={styles.input_form_table}>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{}}
                  label="講座名"
                  name="course_name"
                  isStatic={true}
                />
              </tr>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{}}
                  label="大学ID"
                  name="university_id"
                  isStatic={true}
                />
              </tr>
              <tr>
                <Select
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  label="当選状況"
                  name="lottery_status"
                  errors={errors}
                  options={lotteryStatus}
                  watch={watch}
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <div className={styles.row_in_button}>
                  <TextField
                    errors={errors}
                    register={register}
                    validation={{
                      ...validateRequired("いずれかの学生を選択してください"),
                    }}
                    label="学生番号(8桁)"
                    name="login_id"
                    readOnly={true}
                    isStatic={isConfirmation}
                  />
                  {!isConfirmation ? (
                    <div className={styles.row_in_button__buttonbox}>
                      <Button
                        type="button"
                        styleType="search"
                        onClick={() => showStudentModal()}
                      >
                        学生選択
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </tr>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{}}
                  label="氏名"
                  name="name"
                  isStatic={true}
                />
              </tr>
              <tr>
                <div hidden>
                  <TextField
                    errors={errors}
                    register={register}
                    validation={{}}
                    label=""
                    name="select_user_id"
                    isStatic={true}
                  />
                </div>
              </tr>
              <tr>
                <Select
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  label="未受講・受講中・受講済み"
                  name="attendance_status"
                  errors={errors}
                  options={attendanceStatus}
                  watch={watch}
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <Select
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  label="申込方法"
                  name="how_apply"
                  errors={errors}
                  options={howApply}
                  watch={watch}
                  isStatic={isConfirmation}
                  isSetdefalut={true}
                  defalut={{ text: "---選択していません---", value: 0 }}
                />
              </tr>
              <tr>
                <TextAreaField
                  errors={errors}
                  register={register}
                  validation={{
                    ...validateMaxlength(500),
                  }}
                  label="備考"
                  name="remarks"
                  isStatic={isConfirmation}
                />
              </tr>
              {[...Array(15)].map((_, i) => (
                <tr>
                  <Select
                    register={register}
                    validation={{
                      ...validateRequired(),
                    }}
                    label={i + 1 + "回目(出席・欠席)"}
                    name={"attendance" + (i + 1)}
                    errors={errors}
                    options={attendance}
                    watch={watch}
                    isStatic={isConfirmation}
                    isSetdefalut={true}
                    defalut={{ text: "---選択していません---", value: 0 }}
                  />
                </tr>
              ))}
              <tr></tr>
            </table>

            <div className={styles.buttonbox}>
              {isConfirmation ? (
                <Button
                  type="button"
                  styleType="back"
                  onClick={() => handleBackConfirmation()}
                >
                  変更ページへ戻る
                </Button>
              ) : (
                <Button
                  type="button"
                  styleType="back"
                  onClick={() => handleBack()}
                >
                  申込者詳細へ戻る
                </Button>
              )}
              <Button type="submit" styleType="register">
                {isConfirmation ? "登録" : "確認"}
              </Button>
            </div>
            <div hidden>
              <TextField
                errors={errors}
                register={register}
                validation={{}}
                label=""
                name="updated_at"
                isStatic={true}
              />
            </div>
          </Form>
          {loading ? <Loading /> : <></>}
          {loading ? <Progress /> : <></>}
          {!isConfirmation ? (
            <div className={styles.buttonbox}>
              <Link className={styles.link} to="/admin/top">
                トップページへ戻る
              </Link>
            </div>
          ) : (
            <></>
          )}
          <StudentModal
            course_id={id}
            showFlag={showStudentModalFlag}
            setShowModal={setShowStudentModalFlag}
            setStudentDisplay={setStudentDisplay}
            setStudentInfo={setStudentInfo}
            key={showStudentModalFlag}
          />
        </div>
      )}
    </>
  );
};

export default UpdateCourseApplicant;
